const FunctionsEnum = {
    RACER: {value: '20', label: 'Pretekár'},
    RACER_WITH_CONTRACT: {value: '21', label: 'Pretekár so zmluvou'},
    STATUTORY: {value: '1', label: 'Štatutár'},
    PRESIDENT: {value: '2', label: 'Predseda'},
    BOSS: {value: '22', label: 'Prezident'},
    GENERAL_SECRETARY: {value: '23', label: 'Generálny sekretár'},
}

export default FunctionsEnum;